module.exports = __webpack_public_path__ + "img/Copy.edb84a8e.svg";